/*
 * Dreamy — test de sommeil (S6).
 * computeProfile(answers) : fonction pure, testée (tests/quiz.test.mjs).
 *   q1 = ventre ou q2 = ventre             → B (côté bas de 8 cm)
 *   sinon (larges + ferme) ou (étroites + moelleux) → B
 *   sinon                                  → A
 * Persistance : localStorage.dreamy_profile = {profile, answers, date} ; attribut de panier « Profil sommeil ».
 * Événements : dreamy_quiz_open, dreamy_quiz_step, dreamy_quiz_complete.
 */
(function (root) {
  var D = (root.Dreamy = root.Dreamy || {});
  var KEY = 'dreamy_profile';

  var DEFAULT_LABELS = {
    cote: 'côté',
    dos: 'dos',
    ventre: 'ventre',
    change: 'change souvent',
    etroites: 'épaules étroites',
    moyennes: 'épaules moyennes',
    larges: 'épaules larges',
    ferme: 'matelas ferme',
    equilibre: 'matelas équilibré',
    moelleux: 'matelas moelleux',
  };

  function computeProfile(answers) {
    var a = answers || {};
    var q1 = a.q1_position;
    var q2 = a.q2_reveil;
    var q3 = a.q3_epaules;
    var q4 = a.q4_matelas;
    if (q1 === 'ventre' || q2 === 'ventre') return 'B';
    if ((q3 === 'larges' && q4 === 'ferme') || (q3 === 'etroites' && q4 === 'moelleux')) return 'B';
    return 'A';
  }

  function label(value, labels) {
    var l = labels || DEFAULT_LABELS;
    return l[value] || DEFAULT_LABELS[value] || value || '';
  }

  /* « côté, épaules moyennes » (puce du bloc d'achat) */
  function profileLabel(answers, labels) {
    var a = answers || {};
    return [label(a.q1_position, labels), label(a.q3_epaules, labels)].filter(Boolean).join(', ');
  }

  /* « A — côté, épaules moyennes, matelas équilibré » (attribut de panier) */
  function attributeValue(profile, answers, labels) {
    var a = answers || {};
    var parts = [label(a.q1_position, labels), label(a.q3_epaules, labels), label(a.q4_matelas, labels)].filter(Boolean);
    return profile + ' — ' + parts.join(', ');
  }

  function read() {
    try {
      var raw = root.localStorage && root.localStorage.getItem(KEY);
      var data = raw ? JSON.parse(raw) : null;
      return data && /^[ABC]$/.test(data.profile) ? data : null;
    } catch (e) {
      return null;
    }
  }
  function save(profile, answers) {
    var data = { profile: profile, answers: answers, date: new Date().toISOString() };
    try {
      root.localStorage.setItem(KEY, JSON.stringify(data));
    } catch (e) {
      /* navigation privée : le résultat reste affiché, sans mémorisation */
    }
    return data;
  }

  D.quiz = {
    STORAGE_KEY: KEY,
    DEFAULT_LABELS: DEFAULT_LABELS,
    computeProfile: computeProfile,
    profileLabel: profileLabel,
    attributeValue: attributeValue,
    read: read,
    save: save,
  };

  if (typeof document === 'undefined' || typeof customElements === 'undefined') return;

  function track(name, data) {
    if (D.track) D.track(name, data);
  }

  function parseLabels(str) {
    var out = {};
    String(str || '')
      .split('|')
      .forEach(function (pair) {
        var i = pair.indexOf('=');
        if (i > 0) out[pair.slice(0, i).trim()] = pair.slice(i + 1).trim();
      });
    return Object.keys(out).length ? out : DEFAULT_LABELS;
  }

  /* Attribut de panier « Profil sommeil » (visible sur la commande, sert à personnaliser le rituel) */
  function syncCart(value, attrName) {
    if (!root.routes || !value) return;
    var body = { attributes: {} };
    body.attributes[attrName || 'Profil sommeil'] = value;
    fetch(root.routes.cart_update_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function () {
        try {
          sessionStorage.setItem('dreamy_profile_synced', value);
        } catch (e) {}
      })
      .catch(function () {});
  }

  /* Puce « Votre profil : côté, épaules moyennes ✓ » dans le bloc d'achat */
  function renderChips() {
    var data = read();
    var boxes = document.querySelectorAll('[data-dreamy-profile]');
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      if (!data) {
        box.hidden = true;
        continue;
      }
      var labels = parseLabels(box.getAttribute('data-labels'));
      var lab = box.querySelector('[data-dreamy-profile-label]');
      var verdict = box.querySelector('[data-dreamy-profile-verdict]');
      if (lab) lab.textContent = (box.getAttribute('data-prefix') || 'Votre profil : ') + profileLabel(data.answers, labels);
      if (verdict) {
        var text = box.getAttribute('data-verdict-' + data.profile.toLowerCase()) || '';
        verdict.textContent = '';
        var cut = data.profile === 'C' ? text.lastIndexOf(' — ') : -1;
        if (cut > 0) {
          verdict.appendChild(document.createTextNode(text.slice(0, cut) + ' — '));
          var why = document.createElement('a');
          why.href = '/pages/test-sommeil';
          why.className = 'dr-link dr-link--inline';
          why.setAttribute('data-dreamy-quiz-open', '');
          why.setAttribute('data-quiz-view', 'result');
          why.setAttribute('data-quiz-source', 'pdp');
          why.textContent = text.slice(cut + 3);
          verdict.appendChild(why);
        } else verdict.textContent = text;
      }
      box.hidden = false;
    }
  }
  D.renderProfileChips = renderChips;

  customElements.define(
    'dreamy-quiz',
    class DreamyQuiz extends HTMLElement {
      connectedCallback() {
        this.mode = this.dataset.mode;
        this.answers = {};
        this.questions = Array.prototype.slice.call(this.querySelectorAll('[data-quiz-screen="question"]'));
        this.intro = this.querySelector('[data-quiz-screen="intro"]');
        this.result = this.querySelector('[data-quiz-screen="result"]');
        this.back = this.querySelector('[data-quiz-back]');
        this.step = this.querySelector('[data-quiz-step]');
        this.progress = this.querySelector('[data-quiz-progress]');
        this.fill = this.querySelector('[data-quiz-progress-fill]');
        this.labels = parseLabels(this.dataset.labels);
        this.current = 'intro';

        this.addEventListener('click', (e) => this.onClick(e));
        var form = this.querySelector('[data-dreamy-quiz-newsletter]');
        if (form) form.addEventListener('submit', (e) => this.onNewsletter(e, form));
        this.show('intro', false);
      }

      open(source, view) {
        var saved = read();
        if (view === 'result' && saved) {
          this.answers = Object.assign({}, saved.answers);
          this.showResult(saved.profile);
        } else if (view === 'restart') {
          this.answers = {};
          this.show(0, true);
        } else {
          this.answers = {};
          this.show('intro', true);
        }
        track('dreamy_quiz_open', { source: source || this.mode });
      }

      onClick(e) {
        var t = e.target;
        if (this.busy) return; // réponse en cours de validation ou changement d'écran : pas de double action
        if (t.closest('[data-quiz-start]')) {
          if (this.mode === 'inline' && this.current === 'intro') track('dreamy_quiz_open', { source: 'page' });
          this.show(0, true, 1);
          return;
        }
        var answer = t.closest('.dr-quiz__answer');
        if (answer) {
          this.choose(answer);
          return;
        }
        if (t.closest('[data-quiz-back]')) {
          this.goBack();
          return;
        }
        if (t.closest('[data-quiz-restart]')) {
          this.answers = {};
          this.show(0, true, 1);
          return;
        }
        var cta = t.closest('[data-quiz-cta]');
        if (cta) this.onCta(e, cta);
      }

      choose(button) {
        var screen = button.closest('[data-quiz-screen]');
        var key = screen.dataset.key;
        var index = parseInt(screen.dataset.index, 10);
        this.answers[key] = button.dataset.value;
        Array.prototype.forEach.call(screen.querySelectorAll('.dr-quiz__answer'), (b) =>
          b.setAttribute('aria-pressed', b === button ? 'true' : 'false')
        );
        track('dreamy_quiz_step', { step: index, value: button.dataset.value });
        // La réponse reste 180 ms à l'état sélectionné avant l'écran suivant : on voit son choix.
        this.busy = true;
        setTimeout(() => {
          this.busy = false;
          if (index >= this.questions.length) this.finish();
          else this.show(index, true, 1);
        }, 180);
      }

      goBack() {
        if (this.busy) return;
        if (this.current === 'result') this.show(this.questions.length - 1, true, -1);
        else if (typeof this.current === 'number' && this.current > 0) this.show(this.current - 1, true, -1);
        else this.show('intro', true, -1);
      }

      finish() {
        var profile = computeProfile(this.answers);
        save(profile, this.answers);
        syncCart(attributeValue(profile, this.answers, this.labels), this.dataset.attributeName);
        track('dreamy_quiz_complete', { profile: profile });
        this.showResult(profile, 1);
        renderChips();
      }

      showResult(profile, dir) {
        Array.prototype.forEach.call(this.querySelectorAll('[data-quiz-result]'), (r) => {
          r.hidden = r.dataset.quizResult !== profile;
        });
        Array.prototype.forEach.call(this.querySelectorAll('[data-quiz-cta]'), (c) => {
          c.hidden = c.dataset.quizCta !== profile;
        });
        var tags = this.querySelector('[data-quiz-tags]');
        if (tags) tags.value = 'newsletter,quiz,quiz-' + profile.toLowerCase();
        var ab = this.querySelector('[data-nl-title-ab]');
        var c = this.querySelector('[data-nl-title-c]');
        if (ab) ab.hidden = profile === 'C';
        if (c) c.hidden = profile !== 'C';
        this.profile = profile;
        this.show('result', true, dir);
      }

      // Motion (prompt 4) : dir = 1 (suivant) ou -1 (retour). L'écran sortant part de 16 px en fondu (d-s),
      // le nouveau arrive de 16 px de l'autre côté (d-m). Sans dir (ouverture), en reduced-motion ou dans l'éditeur : instantané.
      show(target, moveFocus, dir) {
        var M = dir && window.Dreamy && Dreamy.motion;
        var old = this.querySelector('[data-quiz-screen]:not([hidden])');
        if (!M || !M.enabled() || !old || !old.animate) return this.render(target, moveFocus, M && M.enabled() ? dir : 0);
        this.busy = true;
        var out = old.animate(
          [{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translate3d(' + -16 * dir + 'px,0,0)' }],
          { duration: M.ms('--d-s'), easing: M.token('--ease-in-out'), fill: 'forwards' }
        );
        out.onfinish = () => {
          this.render(target, moveFocus, dir);
          out.cancel();
        };
      }

      render(target, moveFocus, dir) {
        var screens = [this.intro].concat(this.questions, [this.result]);
        var el;
        if (target === 'intro') el = this.intro;
        else if (target === 'result') el = this.result;
        else el = this.questions[target];
        screens.forEach((s) => {
          if (s) s.hidden = s !== el;
        });
        this.current = target;

        var total = this.questions.length;
        var done = target === 'intro' ? 0 : target === 'result' ? total : target;
        if (this.fill) this.fill.style.transform = 'scaleX(' + (total ? done / total : 0) + ')';
        if (this.progress) {
          this.progress.setAttribute('aria-valuenow', String(done));
          this.progress.hidden = target === 'intro';
        }
        if (this.back) this.back.hidden = target === 'intro';
        if (this.step) {
          if (typeof target === 'number') this.step.textContent = (this.dataset.stepTemplate || 'Question [i] sur [n]').replace('[i]', target + 1).replace('[n]', total);
          else if (target === 'result') this.step.textContent = this.dataset.resultLabel || '';
          else this.step.textContent = '';
        }
        if (moveFocus && el) {
          var title = el.querySelector(target === 'result' ? '[data-quiz-result]:not([hidden]) [tabindex="-1"]' : '[tabindex="-1"]');
          if (title) title.focus({ preventScroll: this.mode === 'modal' });
          if (this.mode === 'inline') this.scrollIntoView({ block: 'start', behavior: 'auto' });
          var scroller = this.closest('dialog');
          if (scroller) scroller.scrollTop = 0;
        }
        this.busy = false;
        var M = dir && el && window.Dreamy && Dreamy.motion;
        if (!M) return;
        if (target !== 'result') {
          M.play(el, [{ opacity: 0, transform: 'translate3d(' + 16 * dir + 'px,0,0)' }, { opacity: 1, transform: 'none' }], '--d-m', '--ease-out');
          return;
        }
        // Résultat : la carte de profil apparaît (fondu + 14 px), puis les conseils en cascade de 80 ms.
        var rise = [{ opacity: 0, transform: 'translate3d(0,14px,0)' }, { opacity: 1, transform: 'none' }];
        M.play(el.querySelector('[data-quiz-result]:not([hidden])'), rise, '--d-l', '--ease-out');
        Array.prototype.slice.call(el.children, 1).forEach((c, i) => M.play(c, rise, '--d-l', '--ease-out', 160 + i * 80));
      }

      onCta(e, cta) {
        var buy = document.getElementById('DreamyBuy');
        if (!buy) return; // lien normal vers la page produit
        e.preventDefault();
        var dialog = this.closest('dialog');
        if (dialog && D.closeDialog) D.closeDialog(dialog);
        renderChips();
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        setTimeout(function () {
          buy.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
          var chip = buy.querySelector('[data-dreamy-profile]');
          if (chip && !chip.hidden) {
            chip.setAttribute('tabindex', '-1');
            chip.focus({ preventScroll: true });
          }
        }, 50);
      }

      onNewsletter(e, form) {
        var email = form.querySelector('input[type="email"]');
        var consent = form.querySelector('[data-quiz-consent]');
        var error = form.querySelector('[data-nl-error]');
        var msg = '';
        if (!email.value || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value)) msg = this.dataset.errorEmail;
        else if (!consent.checked) msg = this.dataset.errorConsent;
        if (msg) {
          e.preventDefault();
          if (error) error.textContent = msg;
          (msg === this.dataset.errorEmail ? email : consent).focus();
        } else {
          try {
            sessionStorage.setItem('dreamy_quiz_newsletter', '1');
          } catch (err) {}
        }
      }
    }
  );

  /* Ouverture depuis tout élément [data-dreamy-quiz-open] (sans JS : lien vers /pages/test-sommeil) */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-dreamy-quiz-open]');
    if (!opener) return;
    var view = opener.getAttribute('data-quiz-view') || (opener.hasAttribute('data-quiz-restart') ? 'restart' : '');
    var source = opener.getAttribute('data-quiz-source') || 'pdp';
    var inline = document.querySelector('dreamy-quiz[data-mode="inline"]');
    var dialog = document.getElementById('DreamyQuiz');
    if (inline) {
      e.preventDefault();
      inline.open(source, view);
      return;
    }
    if (!dialog) return;
    e.preventDefault();
    var quiz = dialog.querySelector('dreamy-quiz');
    if (D.openDialog) D.openDialog(dialog, opener);
    else dialog.showModal();
    if (quiz && quiz.open) quiz.open(source, view);
  });

  function init() {
    renderChips();
    var saved = read();
    // Le profil suit le panier : renvoyé une fois si le panier a été créé après le test.
    if (saved && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (evt) {
        if (!evt || evt.source !== 'product-form') return;
        var quiz = document.querySelector('dreamy-quiz');
        var labels = quiz ? parseLabels(quiz.dataset.labels) : DEFAULT_LABELS;
        var value = attributeValue(saved.profile, saved.answers, labels);
        var synced = null;
        try {
          synced = sessionStorage.getItem('dreamy_profile_synced');
        } catch (err) {}
        if (synced !== value) syncCart(value, quiz && quiz.dataset.attributeName);
      });
    }
    // Retour du formulaire d'inscription facultatif
    // (seulement si l'envoi vient bien du test : la pop-up de bienvenue utilise aussi le formulaire client)
    var fromQuiz = false;
    try {
      fromQuiz = !!sessionStorage.getItem('dreamy_quiz_newsletter');
      sessionStorage.removeItem('dreamy_quiz_newsletter');
    } catch (err) {}
    if (fromQuiz && /[?&]customer_posted=true/.test(window.location.search)) {
      var q = document.querySelector('dreamy-quiz');
      if (q && D.toast) D.toast(q.dataset.newsletterOk);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})(typeof window !== 'undefined' ? window : globalThis);
